import { ENV_VARIABLES } from "../Config/env-config";
export const API_BASE_URL = ENV_VARIABLES.REACT_APP_API_BASE_URL;

// Endpoints
export const API_ENDPOINTS = {
  featureFlags: `${API_BASE_URL}/FeatureFlags`,
  auth: `${API_BASE_URL}/Connect`,
  actions: `${API_BASE_URL}/Actions`,
  categories: `${API_BASE_URL}/Categories`,
  assets: `${API_BASE_URL}/Incidents/Assets`,
  repairers: `${API_BASE_URL}/Incidents/Repairers`,
  incidentRepairers: (incidentId: string) => `${API_BASE_URL}/Incidents/${incidentId}/repairers`,
  deleteIncidentRepairer: (incidentId: string, repairerId: string) =>
    `${API_BASE_URL}/Incidents/${incidentId}/repairers/${repairerId}`,
  users: `${API_BASE_URL}/Users`,
  incidents: `${API_BASE_URL}/Incidents`,
  jobsheets: `${API_BASE_URL}/Incidents/Assets/Jobsheets`,
  incidentJobsheets: (incidentId: string) => `${API_BASE_URL}/Incidents/${incidentId}/Jobsheets`,
  addIncidentJobsheet: (incidentId: string) => `${API_BASE_URL}/Incidents/${incidentId}/Jobsheets`,
  deleteIncidentJobsheet: (incidentId: string, jobsheetId: string) =>
    `${API_BASE_URL}/Incidents/${incidentId}/Jobsheets/${jobsheetId}`,
  contacts: (incidentId: string) => `${API_BASE_URL}/Incidents/${incidentId}/contacts`,
  incidentNotes: (id: string) => `${API_BASE_URL}/Incidents/${id}/Notes`,
  incidentHistory: (id: string) => `${API_BASE_URL}/Incidents/${id}/History`,
  setIncidentHistoryPin: (incidentId: string, incidentHistoryId: string) =>
    `${API_BASE_URL}/Incidents/${incidentId}/History/${incidentHistoryId}/Pin`,
  setIncidentHistoryHighlight: (incidentId: string, incidentHistoryId: string) =>
    `${API_BASE_URL}/Incidents/${incidentId}/History/${incidentHistoryId}/Highlight`,
  updateVORScenario: (incidentId: string, vorScenarioId: string) =>
    `${API_BASE_URL}/Incidents/${incidentId}/VoRScenarios/${vorScenarioId}`,
  addVORScenario: (incidentId: string) => `${API_BASE_URL}/Incidents/${incidentId}/VoRScenarios`,
  addOtherScenario: (incidentId: string) => `${API_BASE_URL}/Incidents/${incidentId}/OtherScenarios`,
  updateOtherScenario: (incidentId: string, otherScenarioId: string) =>
    `${API_BASE_URL}/Incidents/${incidentId}/OtherScenarios/${otherScenarioId}`,
  incidentActions: (incidentId: string) => `${API_BASE_URL}/Incidents/${incidentId}/Actions`,
  completeIncidentAction: (incidentId: string, actionId: string) =>
    `${API_BASE_URL}/Incidents/${incidentId}/Actions/${actionId}/Complete`,
};
